module.exports = __webpack_public_path__ + "img/46200.377288a4.jpg";